var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58398 2.91671C7.58398 2.59454 7.32282 2.33337 7.00065 2.33337C6.67848 2.33337 6.41732 2.59454 6.41732 2.91671V6.41671H2.91732C2.59515 6.41671 2.33398 6.67787 2.33398 7.00004C2.33398 7.32221 2.59515 7.58337 2.91732 7.58337H6.41732V11.0834C6.41732 11.4055 6.67848 11.6667 7.00065 11.6667C7.32282 11.6667 7.58398 11.4055 7.58398 11.0834V7.58337H11.084C11.4062 7.58337 11.6673 7.32221 11.6673 7.00004C11.6673 6.67787 11.4062 6.41671 11.084 6.41671H7.58398V2.91671Z",
    fill: "#1B1918"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackPlusIcon);
export default __webpack_public_path__ + "static/media/black-plus-icon.dd898ddb0d3de15e9bdbf78d19bb9bd5.svg";
export { ForwardRef as ReactComponent };